// src/abis/abis.ts
var poolManagerAbi = [
  {
    type: "function",
    name: "allowance",
    inputs: [
      { name: "owner", type: "address", internalType: "address" },
      { name: "spender", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "amount", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "approve",
    inputs: [
      { name: "spender", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [
      { name: "owner", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "balance", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "burn",
    inputs: [
      { name: "from", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "clear",
    inputs: [
      { name: "currency", type: "address", internalType: "Currency" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "collectProtocolFees",
    inputs: [
      { name: "recipient", type: "address", internalType: "address" },
      { name: "currency", type: "address", internalType: "Currency" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [
      { name: "amountCollected", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "donate",
    inputs: [
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "amount0", type: "uint256", internalType: "uint256" },
      { name: "amount1", type: "uint256", internalType: "uint256" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "delta", type: "int256", internalType: "BalanceDelta" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "extsload",
    inputs: [{ name: "slot", type: "bytes32", internalType: "bytes32" }],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "extsload",
    inputs: [
      { name: "startSlot", type: "bytes32", internalType: "bytes32" },
      { name: "nSlots", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bytes32[]", internalType: "bytes32[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "extsload",
    inputs: [{ name: "slots", type: "bytes32[]", internalType: "bytes32[]" }],
    outputs: [{ name: "", type: "bytes32[]", internalType: "bytes32[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "exttload",
    inputs: [{ name: "slots", type: "bytes32[]", internalType: "bytes32[]" }],
    outputs: [{ name: "", type: "bytes32[]", internalType: "bytes32[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "exttload",
    inputs: [{ name: "slot", type: "bytes32", internalType: "bytes32" }],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "tick", type: "int24", internalType: "int24" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "isOperator",
    inputs: [
      { name: "owner", type: "address", internalType: "address" },
      { name: "operator", type: "address", internalType: "address" }
    ],
    outputs: [{ name: "isOperator", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "mint",
    inputs: [
      { name: "to", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "modifyLiquidity",
    inputs: [
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.ModifyLiquidityParams",
        components: [
          { name: "tickLower", type: "int24", internalType: "int24" },
          { name: "tickUpper", type: "int24", internalType: "int24" },
          { name: "liquidityDelta", type: "int256", internalType: "int256" },
          { name: "salt", type: "bytes32", internalType: "bytes32" }
        ]
      },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "callerDelta", type: "int256", internalType: "BalanceDelta" },
      { name: "feesAccrued", type: "int256", internalType: "BalanceDelta" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "protocolFeeController",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IProtocolFeeController"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "protocolFeesAccrued",
    inputs: [{ name: "currency", type: "address", internalType: "Currency" }],
    outputs: [{ name: "amount", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "setOperator",
    inputs: [
      { name: "operator", type: "address", internalType: "address" },
      { name: "approved", type: "bool", internalType: "bool" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setProtocolFee",
    inputs: [
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "newProtocolFee", type: "uint24", internalType: "uint24" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setProtocolFeeController",
    inputs: [
      {
        name: "controller",
        type: "address",
        internalType: "contract IProtocolFeeController"
      }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "settle",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "settleFor",
    inputs: [{ name: "recipient", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "supportsInterface",
    inputs: [{ name: "interfaceId", type: "bytes4", internalType: "bytes4" }],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "swap",
    inputs: [
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.SwapParams",
        components: [
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "amountSpecified", type: "int256", internalType: "int256" },
          {
            name: "sqrtPriceLimitX96",
            type: "uint160",
            internalType: "uint160"
          }
        ]
      },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "swapDelta", type: "int256", internalType: "BalanceDelta" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "sync",
    inputs: [{ name: "currency", type: "address", internalType: "Currency" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "take",
    inputs: [
      { name: "currency", type: "address", internalType: "Currency" },
      { name: "to", type: "address", internalType: "address" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      { name: "receiver", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferFrom",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      { name: "receiver", type: "address", internalType: "address" },
      { name: "id", type: "uint256", internalType: "uint256" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [{ name: "newOwner", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unlock",
    inputs: [{ name: "data", type: "bytes", internalType: "bytes" }],
    outputs: [{ name: "result", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "updateDynamicLPFee",
    inputs: [
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "newDynamicLPFee", type: "uint24", internalType: "uint24" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "spender",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      { name: "id", type: "uint256", indexed: true, internalType: "uint256" },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Donate",
    inputs: [
      { name: "id", type: "bytes32", indexed: true, internalType: "PoolId" },
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "amount0",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "amount1",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Initialize",
    inputs: [
      { name: "id", type: "bytes32", indexed: true, internalType: "PoolId" },
      {
        name: "currency0",
        type: "address",
        indexed: true,
        internalType: "Currency"
      },
      {
        name: "currency1",
        type: "address",
        indexed: true,
        internalType: "Currency"
      },
      { name: "fee", type: "uint24", indexed: false, internalType: "uint24" },
      {
        name: "tickSpacing",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "hooks",
        type: "address",
        indexed: false,
        internalType: "contract IHooks"
      },
      {
        name: "sqrtPriceX96",
        type: "uint160",
        indexed: false,
        internalType: "uint160"
      },
      { name: "tick", type: "int24", indexed: false, internalType: "int24" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ModifyLiquidity",
    inputs: [
      { name: "id", type: "bytes32", indexed: true, internalType: "PoolId" },
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "tickLower",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "tickUpper",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "liquidityDelta",
        type: "int256",
        indexed: false,
        internalType: "int256"
      },
      {
        name: "salt",
        type: "bytes32",
        indexed: false,
        internalType: "bytes32"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "OperatorSet",
    inputs: [
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "operator",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      { name: "approved", type: "bool", indexed: false, internalType: "bool" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      { name: "user", type: "address", indexed: true, internalType: "address" },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ProtocolFeeControllerUpdated",
    inputs: [
      {
        name: "protocolFeeController",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "ProtocolFeeUpdated",
    inputs: [
      { name: "id", type: "bytes32", indexed: true, internalType: "PoolId" },
      {
        name: "protocolFee",
        type: "uint24",
        indexed: false,
        internalType: "uint24"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Swap",
    inputs: [
      { name: "id", type: "bytes32", indexed: true, internalType: "PoolId" },
      {
        name: "sender",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "amount0",
        type: "int128",
        indexed: false,
        internalType: "int128"
      },
      {
        name: "amount1",
        type: "int128",
        indexed: false,
        internalType: "int128"
      },
      {
        name: "sqrtPriceX96",
        type: "uint160",
        indexed: false,
        internalType: "uint160"
      },
      {
        name: "liquidity",
        type: "uint128",
        indexed: false,
        internalType: "uint128"
      },
      { name: "tick", type: "int24", indexed: false, internalType: "int24" },
      { name: "fee", type: "uint24", indexed: false, internalType: "uint24" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      {
        name: "caller",
        type: "address",
        indexed: false,
        internalType: "address"
      },
      { name: "from", type: "address", indexed: true, internalType: "address" },
      { name: "to", type: "address", indexed: true, internalType: "address" },
      { name: "id", type: "uint256", indexed: true, internalType: "uint256" },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  { type: "error", name: "AlreadyUnlocked", inputs: [] },
  { type: "error", name: "ContractUnlocked", inputs: [] },
  {
    type: "error",
    name: "CurrenciesOutOfOrderOrEqual",
    inputs: [
      { name: "currency0", type: "address", internalType: "address" },
      { name: "currency1", type: "address", internalType: "address" }
    ]
  },
  { type: "error", name: "CurrencyNotSettled", inputs: [] },
  { type: "error", name: "DelegateCallNotAllowed", inputs: [] },
  { type: "error", name: "InvalidBips", inputs: [] },
  { type: "error", name: "InvalidCaller", inputs: [] },
  { type: "error", name: "ManagerLocked", inputs: [] },
  { type: "error", name: "MustClearExactPositiveDelta", inputs: [] },
  { type: "error", name: "NonzeroNativeValue", inputs: [] },
  { type: "error", name: "PoolNotInitialized", inputs: [] },
  { type: "error", name: "ProtocolFeeCannotBeFetched", inputs: [] },
  {
    type: "error",
    name: "ProtocolFeeTooLarge",
    inputs: [{ name: "fee", type: "uint24", internalType: "uint24" }]
  },
  { type: "error", name: "SwapAmountCannotBeZero", inputs: [] },
  {
    type: "error",
    name: "TickSpacingTooLarge",
    inputs: [{ name: "tickSpacing", type: "int24", internalType: "int24" }]
  },
  {
    type: "error",
    name: "TickSpacingTooSmall",
    inputs: [{ name: "tickSpacing", type: "int24", internalType: "int24" }]
  },
  { type: "error", name: "UnauthorizedDynamicLPFeeUpdate", inputs: [] }
];
var stateViewAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_poolManager",
        type: "address",
        internalType: "contract IPoolManager"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getFeeGrowthGlobals",
    inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }],
    outputs: [
      { name: "feeGrowthGlobal0", type: "uint256", internalType: "uint256" },
      { name: "feeGrowthGlobal1", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getFeeGrowthInside",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "tickLower", type: "int24", internalType: "int24" },
      { name: "tickUpper", type: "int24", internalType: "int24" }
    ],
    outputs: [
      {
        name: "feeGrowthInside0X128",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "feeGrowthInside1X128",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getLiquidity",
    inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }],
    outputs: [{ name: "liquidity", type: "uint128", internalType: "uint128" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPositionInfo",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "positionId", type: "bytes32", internalType: "bytes32" }
    ],
    outputs: [
      { name: "liquidity", type: "uint128", internalType: "uint128" },
      {
        name: "feeGrowthInside0LastX128",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "feeGrowthInside1LastX128",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPositionInfo",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "owner", type: "address", internalType: "address" },
      { name: "tickLower", type: "int24", internalType: "int24" },
      { name: "tickUpper", type: "int24", internalType: "int24" },
      { name: "salt", type: "bytes32", internalType: "bytes32" }
    ],
    outputs: [
      { name: "liquidity", type: "uint128", internalType: "uint128" },
      {
        name: "feeGrowthInside0LastX128",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "feeGrowthInside1LastX128",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPositionLiquidity",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "positionId", type: "bytes32", internalType: "bytes32" }
    ],
    outputs: [{ name: "liquidity", type: "uint128", internalType: "uint128" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getSlot0",
    inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }],
    outputs: [
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
      { name: "tick", type: "int24", internalType: "int24" },
      { name: "protocolFee", type: "uint24", internalType: "uint24" },
      { name: "lpFee", type: "uint24", internalType: "uint24" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTickBitmap",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "tick", type: "int16", internalType: "int16" }
    ],
    outputs: [{ name: "tickBitmap", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTickFeeGrowthOutside",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "tick", type: "int24", internalType: "int24" }
    ],
    outputs: [
      {
        name: "feeGrowthOutside0X128",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "feeGrowthOutside1X128",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTickInfo",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "tick", type: "int24", internalType: "int24" }
    ],
    outputs: [
      { name: "liquidityGross", type: "uint128", internalType: "uint128" },
      { name: "liquidityNet", type: "int128", internalType: "int128" },
      {
        name: "feeGrowthOutside0X128",
        type: "uint256",
        internalType: "uint256"
      },
      {
        name: "feeGrowthOutside1X128",
        type: "uint256",
        internalType: "uint256"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getTickLiquidity",
    inputs: [
      { name: "poolId", type: "bytes32", internalType: "PoolId" },
      { name: "tick", type: "int24", internalType: "int24" }
    ],
    outputs: [
      { name: "liquidityGross", type: "uint128", internalType: "uint128" },
      { name: "liquidityNet", type: "int128", internalType: "int128" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPoolManager" }
    ],
    stateMutability: "view"
  }
];
var airlockAbi = [
  {
    type: "constructor",
    inputs: [{ name: "owner_", type: "address", internalType: "address" }],
    stateMutability: "nonpayable"
  },
  { type: "receive", stateMutability: "payable" },
  {
    type: "function",
    name: "collectIntegratorFees",
    inputs: [
      { name: "to", type: "address", internalType: "address" },
      { name: "token", type: "address", internalType: "address" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "collectProtocolFees",
    inputs: [
      { name: "to", type: "address", internalType: "address" },
      { name: "token", type: "address", internalType: "address" },
      { name: "amount", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "create",
    inputs: [
      {
        name: "createData",
        type: "tuple",
        internalType: "struct CreateParams",
        components: [
          { name: "initialSupply", type: "uint256", internalType: "uint256" },
          { name: "numTokensToSell", type: "uint256", internalType: "uint256" },
          { name: "numeraire", type: "address", internalType: "address" },
          {
            name: "tokenFactory",
            type: "address",
            internalType: "contract ITokenFactory"
          },
          { name: "tokenFactoryData", type: "bytes", internalType: "bytes" },
          {
            name: "governanceFactory",
            type: "address",
            internalType: "contract IGovernanceFactory"
          },
          {
            name: "governanceFactoryData",
            type: "bytes",
            internalType: "bytes"
          },
          {
            name: "poolInitializer",
            type: "address",
            internalType: "contract IPoolInitializer"
          },
          { name: "poolInitializerData", type: "bytes", internalType: "bytes" },
          {
            name: "liquidityMigrator",
            type: "address",
            internalType: "contract ILiquidityMigrator"
          },
          {
            name: "liquidityMigratorData",
            type: "bytes",
            internalType: "bytes"
          },
          { name: "integrator", type: "address", internalType: "address" },
          { name: "salt", type: "bytes32", internalType: "bytes32" }
        ]
      }
    ],
    outputs: [
      { name: "asset", type: "address", internalType: "address" },
      { name: "pool", type: "address", internalType: "address" },
      { name: "governance", type: "address", internalType: "address" },
      { name: "timelock", type: "address", internalType: "address" },
      { name: "migrationPool", type: "address", internalType: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "getAssetData",
    inputs: [{ name: "asset", type: "address", internalType: "address" }],
    outputs: [
      { name: "numeraire", type: "address", internalType: "address" },
      { name: "timelock", type: "address", internalType: "address" },
      { name: "governance", type: "address", internalType: "address" },
      {
        name: "liquidityMigrator",
        type: "address",
        internalType: "contract ILiquidityMigrator"
      },
      {
        name: "poolInitializer",
        type: "address",
        internalType: "contract IPoolInitializer"
      },
      { name: "pool", type: "address", internalType: "address" },
      { name: "migrationPool", type: "address", internalType: "address" },
      { name: "numTokensToSell", type: "uint256", internalType: "uint256" },
      { name: "totalSupply", type: "uint256", internalType: "uint256" },
      { name: "integrator", type: "address", internalType: "address" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getModuleState",
    inputs: [{ name: "module", type: "address", internalType: "address" }],
    outputs: [
      { name: "state", type: "uint8", internalType: "enum ModuleState" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "integratorFees",
    inputs: [
      { name: "integrator", type: "address", internalType: "address" },
      { name: "token", type: "address", internalType: "address" }
    ],
    outputs: [{ name: "amount", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [{ name: "asset", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "protocolFees",
    inputs: [{ name: "token", type: "address", internalType: "address" }],
    outputs: [{ name: "amount", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "setModuleState",
    inputs: [
      { name: "modules", type: "address[]", internalType: "address[]" },
      { name: "states", type: "uint8[]", internalType: "enum ModuleState[]" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [{ name: "newOwner", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "Collect",
    inputs: [
      { name: "to", type: "address", indexed: true, internalType: "address" },
      {
        name: "token",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Create",
    inputs: [
      {
        name: "asset",
        type: "address",
        indexed: false,
        internalType: "address"
      },
      {
        name: "numeraire",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "initializer",
        type: "address",
        indexed: false,
        internalType: "address"
      },
      {
        name: "poolOrHook",
        type: "address",
        indexed: false,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Migrate",
    inputs: [
      {
        name: "asset",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      { name: "pool", type: "address", indexed: true, internalType: "address" }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "SetModuleState",
    inputs: [
      {
        name: "module",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "state",
        type: "uint8",
        indexed: true,
        internalType: "enum ModuleState"
      }
    ],
    anonymous: false
  },
  { type: "error", name: "ArrayLengthsMismatch", inputs: [] },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [{ name: "owner", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [{ name: "account", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "WrongModuleState",
    inputs: [
      { name: "module", type: "address", internalType: "address" },
      { name: "expected", type: "uint8", internalType: "enum ModuleState" },
      { name: "actual", type: "uint8", internalType: "enum ModuleState" }
    ]
  }
];
var governanceFactoryAbi = [
  {
    type: "constructor",
    inputs: [{ name: "airlock_", type: "address", internalType: "address" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "airlock",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "contract Airlock" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "create",
    inputs: [
      { name: "asset", type: "address", internalType: "address" },
      { name: "data", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "", type: "address", internalType: "address" },
      { name: "", type: "address", internalType: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "timelockFactory",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract TimelockFactory" }
    ],
    stateMutability: "view"
  },
  { type: "error", name: "SenderNotAirlock", inputs: [] }
];
var uniswapV4InitializerAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "airlock_", type: "address", internalType: "address" },
      {
        name: "poolManager_",
        type: "address",
        internalType: "contract IPoolManager"
      },
      {
        name: "deployer_",
        type: "address",
        internalType: "contract DopplerDeployer"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "airlock",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "contract Airlock" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "deployer",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract DopplerDeployer" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "exitLiquidity",
    inputs: [{ name: "hook", type: "address", internalType: "address" }],
    outputs: [
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
      { name: "token0", type: "address", internalType: "address" },
      { name: "fees0", type: "uint128", internalType: "uint128" },
      { name: "balance0", type: "uint128", internalType: "uint128" },
      { name: "token1", type: "address", internalType: "address" },
      { name: "fees1", type: "uint128", internalType: "uint128" },
      { name: "balance1", type: "uint128", internalType: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      { name: "asset", type: "address", internalType: "address" },
      { name: "numeraire", type: "address", internalType: "address" },
      { name: "numTokensToSell", type: "uint256", internalType: "uint256" },
      { name: "salt", type: "bytes32", internalType: "bytes32" },
      { name: "data", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPoolManager" }
    ],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "Create",
    inputs: [
      {
        name: "poolOrHook",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "asset",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "numeraire",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  { type: "error", name: "InvalidTokenOrder", inputs: [] },
  { type: "error", name: "SenderNotAirlock", inputs: [] }
];
var universalRouterAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct RouterParameters",
        components: [
          { name: "permit2", type: "address", internalType: "address" },
          { name: "weth9", type: "address", internalType: "address" },
          { name: "v2Factory", type: "address", internalType: "address" },
          { name: "v3Factory", type: "address", internalType: "address" },
          {
            name: "pairInitCodeHash",
            type: "bytes32",
            internalType: "bytes32"
          },
          {
            name: "poolInitCodeHash",
            type: "bytes32",
            internalType: "bytes32"
          },
          { name: "v4PoolManager", type: "address", internalType: "address" },
          {
            name: "v3NFTPositionManager",
            type: "address",
            internalType: "address"
          },
          {
            name: "v4PositionManager",
            type: "address",
            internalType: "address"
          }
        ]
      }
    ],
    stateMutability: "nonpayable"
  },
  { type: "receive", stateMutability: "payable" },
  {
    type: "function",
    name: "V3_POSITION_MANAGER",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract INonfungiblePositionManager"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "V4_POSITION_MANAGER",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPositionManager" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "execute",
    inputs: [
      { name: "commands", type: "bytes", internalType: "bytes" },
      { name: "inputs", type: "bytes[]", internalType: "bytes[]" }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "execute",
    inputs: [
      { name: "commands", type: "bytes", internalType: "bytes" },
      { name: "inputs", type: "bytes[]", internalType: "bytes[]" },
      { name: "deadline", type: "uint256", internalType: "uint256" }
    ],
    outputs: [],
    stateMutability: "payable"
  },
  {
    type: "function",
    name: "msgSender",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPoolManager" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "uniswapV3SwapCallback",
    inputs: [
      { name: "amount0Delta", type: "int256", internalType: "int256" },
      { name: "amount1Delta", type: "int256", internalType: "int256" },
      { name: "data", type: "bytes", internalType: "bytes" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unlockCallback",
    inputs: [{ name: "data", type: "bytes", internalType: "bytes" }],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  { type: "error", name: "BalanceTooLow", inputs: [] },
  { type: "error", name: "ContractLocked", inputs: [] },
  {
    type: "error",
    name: "DeltaNotNegative",
    inputs: [{ name: "currency", type: "address", internalType: "Currency" }]
  },
  {
    type: "error",
    name: "DeltaNotPositive",
    inputs: [{ name: "currency", type: "address", internalType: "Currency" }]
  },
  { type: "error", name: "ETHNotAccepted", inputs: [] },
  {
    type: "error",
    name: "ExecutionFailed",
    inputs: [
      { name: "commandIndex", type: "uint256", internalType: "uint256" },
      { name: "message", type: "bytes", internalType: "bytes" }
    ]
  },
  { type: "error", name: "FromAddressIsNotOwner", inputs: [] },
  { type: "error", name: "InputLengthMismatch", inputs: [] },
  { type: "error", name: "InsufficientBalance", inputs: [] },
  { type: "error", name: "InsufficientETH", inputs: [] },
  { type: "error", name: "InsufficientToken", inputs: [] },
  {
    type: "error",
    name: "InvalidAction",
    inputs: [{ name: "action", type: "bytes4", internalType: "bytes4" }]
  },
  { type: "error", name: "InvalidBips", inputs: [] },
  {
    type: "error",
    name: "InvalidCommandType",
    inputs: [{ name: "commandType", type: "uint256", internalType: "uint256" }]
  },
  { type: "error", name: "InvalidEthSender", inputs: [] },
  { type: "error", name: "InvalidPath", inputs: [] },
  { type: "error", name: "InvalidReserves", inputs: [] },
  { type: "error", name: "LengthMismatch", inputs: [] },
  {
    type: "error",
    name: "NotAuthorizedForToken",
    inputs: [{ name: "tokenId", type: "uint256", internalType: "uint256" }]
  },
  { type: "error", name: "NotPoolManager", inputs: [] },
  { type: "error", name: "OnlyMintAllowed", inputs: [] },
  { type: "error", name: "SliceOutOfBounds", inputs: [] },
  { type: "error", name: "TransactionDeadlinePassed", inputs: [] },
  { type: "error", name: "UnsafeCast", inputs: [] },
  {
    type: "error",
    name: "UnsupportedAction",
    inputs: [{ name: "action", type: "uint256", internalType: "uint256" }]
  },
  { type: "error", name: "V2InvalidPath", inputs: [] },
  { type: "error", name: "V2TooLittleReceived", inputs: [] },
  { type: "error", name: "V2TooMuchRequested", inputs: [] },
  { type: "error", name: "V3InvalidAmountOut", inputs: [] },
  { type: "error", name: "V3InvalidCaller", inputs: [] },
  { type: "error", name: "V3InvalidSwap", inputs: [] },
  { type: "error", name: "V3TooLittleReceived", inputs: [] },
  { type: "error", name: "V3TooMuchRequested", inputs: [] },
  {
    type: "error",
    name: "V4TooLittleReceived",
    inputs: [
      {
        name: "minAmountOutReceived",
        type: "uint256",
        internalType: "uint256"
      },
      { name: "amountReceived", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "V4TooMuchRequested",
    inputs: [
      {
        name: "maxAmountInRequested",
        type: "uint256",
        internalType: "uint256"
      },
      { name: "amountRequested", type: "uint256", internalType: "uint256" }
    ]
  }
];
var dopplerAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_poolManager",
        type: "address",
        internalType: "contract IPoolManager"
      },
      { name: "_numTokensToSell", type: "uint256", internalType: "uint256" },
      { name: "_minimumProceeds", type: "uint256", internalType: "uint256" },
      { name: "_maximumProceeds", type: "uint256", internalType: "uint256" },
      { name: "_startingTime", type: "uint256", internalType: "uint256" },
      { name: "_endingTime", type: "uint256", internalType: "uint256" },
      { name: "_startingTick", type: "int24", internalType: "int24" },
      { name: "_endingTick", type: "int24", internalType: "int24" },
      { name: "_epochLength", type: "uint256", internalType: "uint256" },
      { name: "_gamma", type: "int24", internalType: "int24" },
      { name: "_isToken0", type: "bool", internalType: "bool" },
      { name: "_numPDSlugs", type: "uint256", internalType: "uint256" },
      { name: "initializer_", type: "address", internalType: "address" },
      { name: "initialLpFee_", type: "uint24", internalType: "uint24" }
    ],
    stateMutability: "nonpayable"
  },
  { type: "receive", stateMutability: "payable" },
  {
    type: "function",
    name: "afterAddLiquidity",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.ModifyLiquidityParams",
        components: [
          { name: "tickLower", type: "int24", internalType: "int24" },
          { name: "tickUpper", type: "int24", internalType: "int24" },
          { name: "liquidityDelta", type: "int256", internalType: "int256" },
          { name: "salt", type: "bytes32", internalType: "bytes32" }
        ]
      },
      { name: "delta", type: "int256", internalType: "BalanceDelta" },
      { name: "feesAccrued", type: "int256", internalType: "BalanceDelta" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes4", internalType: "bytes4" },
      { name: "", type: "int256", internalType: "BalanceDelta" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "afterDonate",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "amount0", type: "uint256", internalType: "uint256" },
      { name: "amount1", type: "uint256", internalType: "uint256" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "afterInitialize",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
      { name: "tick", type: "int24", internalType: "int24" }
    ],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "afterRemoveLiquidity",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.ModifyLiquidityParams",
        components: [
          { name: "tickLower", type: "int24", internalType: "int24" },
          { name: "tickUpper", type: "int24", internalType: "int24" },
          { name: "liquidityDelta", type: "int256", internalType: "int256" },
          { name: "salt", type: "bytes32", internalType: "bytes32" }
        ]
      },
      { name: "delta", type: "int256", internalType: "BalanceDelta" },
      { name: "feesAccrued", type: "int256", internalType: "BalanceDelta" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes4", internalType: "bytes4" },
      { name: "", type: "int256", internalType: "BalanceDelta" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "afterSwap",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.SwapParams",
        components: [
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "amountSpecified", type: "int256", internalType: "int256" },
          {
            name: "sqrtPriceLimitX96",
            type: "uint160",
            internalType: "uint160"
          }
        ]
      },
      { name: "delta", type: "int256", internalType: "BalanceDelta" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes4", internalType: "bytes4" },
      { name: "", type: "int128", internalType: "int128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "beforeAddLiquidity",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.ModifyLiquidityParams",
        components: [
          { name: "tickLower", type: "int24", internalType: "int24" },
          { name: "tickUpper", type: "int24", internalType: "int24" },
          { name: "liquidityDelta", type: "int256", internalType: "int256" },
          { name: "salt", type: "bytes32", internalType: "bytes32" }
        ]
      },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "beforeDonate",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "amount0", type: "uint256", internalType: "uint256" },
      { name: "amount1", type: "uint256", internalType: "uint256" },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "beforeInitialize",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" }
    ],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "beforeRemoveLiquidity",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.ModifyLiquidityParams",
        components: [
          { name: "tickLower", type: "int24", internalType: "int24" },
          { name: "tickUpper", type: "int24", internalType: "int24" },
          { name: "liquidityDelta", type: "int256", internalType: "int256" },
          { name: "salt", type: "bytes32", internalType: "bytes32" }
        ]
      },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "beforeSwap",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      {
        name: "key",
        type: "tuple",
        internalType: "struct PoolKey",
        components: [
          { name: "currency0", type: "address", internalType: "Currency" },
          { name: "currency1", type: "address", internalType: "Currency" },
          { name: "fee", type: "uint24", internalType: "uint24" },
          { name: "tickSpacing", type: "int24", internalType: "int24" },
          { name: "hooks", type: "address", internalType: "contract IHooks" }
        ]
      },
      {
        name: "params",
        type: "tuple",
        internalType: "struct IPoolManager.SwapParams",
        components: [
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "amountSpecified", type: "int256", internalType: "int256" },
          {
            name: "sqrtPriceLimitX96",
            type: "uint160",
            internalType: "uint160"
          }
        ]
      },
      { name: "hookData", type: "bytes", internalType: "bytes" }
    ],
    outputs: [
      { name: "", type: "bytes4", internalType: "bytes4" },
      { name: "", type: "int256", internalType: "BeforeSwapDelta" },
      { name: "", type: "uint24", internalType: "uint24" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "earlyExit",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "endingTick",
    inputs: [],
    outputs: [{ name: "", type: "int24", internalType: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "endingTime",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "epochLength",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "gamma",
    inputs: [],
    outputs: [{ name: "", type: "int24", internalType: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getHookPermissions",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct Hooks.Permissions",
        components: [
          { name: "beforeInitialize", type: "bool", internalType: "bool" },
          { name: "afterInitialize", type: "bool", internalType: "bool" },
          { name: "beforeAddLiquidity", type: "bool", internalType: "bool" },
          { name: "afterAddLiquidity", type: "bool", internalType: "bool" },
          { name: "beforeRemoveLiquidity", type: "bool", internalType: "bool" },
          { name: "afterRemoveLiquidity", type: "bool", internalType: "bool" },
          { name: "beforeSwap", type: "bool", internalType: "bool" },
          { name: "afterSwap", type: "bool", internalType: "bool" },
          { name: "beforeDonate", type: "bool", internalType: "bool" },
          { name: "afterDonate", type: "bool", internalType: "bool" },
          { name: "beforeSwapReturnDelta", type: "bool", internalType: "bool" },
          { name: "afterSwapReturnDelta", type: "bool", internalType: "bool" },
          {
            name: "afterAddLiquidityReturnDelta",
            type: "bool",
            internalType: "bool"
          },
          {
            name: "afterRemoveLiquidityReturnDelta",
            type: "bool",
            internalType: "bool"
          }
        ]
      }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    name: "initializer",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "insufficientProceeds",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isInitialized",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isToken0",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "maximumProceeds",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "migrate",
    inputs: [{ name: "recipient", type: "address", internalType: "address" }],
    outputs: [
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
      { name: "token0", type: "address", internalType: "address" },
      { name: "fees0", type: "uint128", internalType: "uint128" },
      { name: "balance0", type: "uint128", internalType: "uint128" },
      { name: "token1", type: "address", internalType: "address" },
      { name: "fees1", type: "uint128", internalType: "uint128" },
      { name: "balance1", type: "uint128", internalType: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "minimumProceeds",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "numPDSlugs",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "numTokensToSell",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "poolKey",
    inputs: [],
    outputs: [
      { name: "currency0", type: "address", internalType: "Currency" },
      { name: "currency1", type: "address", internalType: "Currency" },
      { name: "fee", type: "uint24", internalType: "uint24" },
      { name: "tickSpacing", type: "int24", internalType: "int24" },
      { name: "hooks", type: "address", internalType: "contract IHooks" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPoolManager" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "positions",
    inputs: [{ name: "salt", type: "bytes32", internalType: "bytes32" }],
    outputs: [
      { name: "tickLower", type: "int24", internalType: "int24" },
      { name: "tickUpper", type: "int24", internalType: "int24" },
      { name: "liquidity", type: "uint128", internalType: "uint128" },
      { name: "salt", type: "uint8", internalType: "uint8" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "startingTick",
    inputs: [],
    outputs: [{ name: "", type: "int24", internalType: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "startingTime",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "state",
    inputs: [],
    outputs: [
      { name: "lastEpoch", type: "uint40", internalType: "uint40" },
      { name: "tickAccumulator", type: "int256", internalType: "int256" },
      { name: "totalTokensSold", type: "uint256", internalType: "uint256" },
      { name: "totalProceeds", type: "uint256", internalType: "uint256" },
      {
        name: "totalTokensSoldLastEpoch",
        type: "uint256",
        internalType: "uint256"
      },
      { name: "feesAccrued", type: "int256", internalType: "BalanceDelta" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "unlockCallback",
    inputs: [{ name: "data", type: "bytes", internalType: "bytes" }],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    name: "EarlyExit",
    inputs: [
      {
        name: "epoch",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  { type: "event", name: "InsufficientProceeds", inputs: [], anonymous: false },
  {
    type: "event",
    name: "Rebalance",
    inputs: [
      {
        name: "currentTick",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "tickLower",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "tickUpper",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "epoch",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Swap",
    inputs: [
      {
        name: "currentTick",
        type: "int24",
        indexed: false,
        internalType: "int24"
      },
      {
        name: "totalProceeds",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "totalTokensSold",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  { type: "error", name: "AlreadyInitialized", inputs: [] },
  { type: "error", name: "CannotAddLiquidity", inputs: [] },
  { type: "error", name: "CannotDonate", inputs: [] },
  { type: "error", name: "CannotMigrate", inputs: [] },
  { type: "error", name: "CannotSwapBeforeStartTime", inputs: [] },
  { type: "error", name: "HookNotImplemented", inputs: [] },
  { type: "error", name: "InvalidEpochLength", inputs: [] },
  { type: "error", name: "InvalidGamma", inputs: [] },
  { type: "error", name: "InvalidNumPDSlugs", inputs: [] },
  { type: "error", name: "InvalidProceedLimits", inputs: [] },
  { type: "error", name: "InvalidStartTime", inputs: [] },
  {
    type: "error",
    name: "InvalidSwapAfterMaturityInsufficientProceeds",
    inputs: []
  },
  {
    type: "error",
    name: "InvalidSwapAfterMaturitySufficientProceeds",
    inputs: []
  },
  { type: "error", name: "InvalidTickRange", inputs: [] },
  { type: "error", name: "InvalidTickSpacing", inputs: [] },
  { type: "error", name: "InvalidTimeRange", inputs: [] },
  { type: "error", name: "MaximumProceedsReached", inputs: [] },
  { type: "error", name: "NotPoolManager", inputs: [] },
  { type: "error", name: "SenderNotInitializer", inputs: [] },
  { type: "error", name: "SenderNotPoolManager", inputs: [] },
  { type: "error", name: "SwapBelowRange", inputs: [] }
];
var v4QuoterAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_poolManager",
        type: "address",
        internalType: "contract IPoolManager"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "_quoteExactInput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          { name: "exactCurrency", type: "address", internalType: "Currency" },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency"
              },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              },
              { name: "hookData", type: "bytes", internalType: "bytes" }
            ]
          },
          { name: "exactAmount", type: "uint128", internalType: "uint128" }
        ]
      }
    ],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "_quoteExactInputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              { name: "currency0", type: "address", internalType: "Currency" },
              { name: "currency1", type: "address", internalType: "Currency" },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              }
            ]
          },
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "exactAmount", type: "uint128", internalType: "uint128" },
          { name: "hookData", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "_quoteExactOutput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          { name: "exactCurrency", type: "address", internalType: "Currency" },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency"
              },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              },
              { name: "hookData", type: "bytes", internalType: "bytes" }
            ]
          },
          { name: "exactAmount", type: "uint128", internalType: "uint128" }
        ]
      }
    ],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "_quoteExactOutputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              { name: "currency0", type: "address", internalType: "Currency" },
              { name: "currency1", type: "address", internalType: "Currency" },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              }
            ]
          },
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "exactAmount", type: "uint128", internalType: "uint128" },
          { name: "hookData", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPoolManager" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteExactInput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          { name: "exactCurrency", type: "address", internalType: "Currency" },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency"
              },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              },
              { name: "hookData", type: "bytes", internalType: "bytes" }
            ]
          },
          { name: "exactAmount", type: "uint128", internalType: "uint128" }
        ]
      }
    ],
    outputs: [
      { name: "amountOut", type: "uint256", internalType: "uint256" },
      { name: "gasEstimate", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "quoteExactInputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              { name: "currency0", type: "address", internalType: "Currency" },
              { name: "currency1", type: "address", internalType: "Currency" },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              }
            ]
          },
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "exactAmount", type: "uint128", internalType: "uint128" },
          { name: "hookData", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [
      { name: "amountOut", type: "uint256", internalType: "uint256" },
      { name: "gasEstimate", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "quoteExactOutput",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactParams",
        components: [
          { name: "exactCurrency", type: "address", internalType: "Currency" },
          {
            name: "path",
            type: "tuple[]",
            internalType: "struct PathKey[]",
            components: [
              {
                name: "intermediateCurrency",
                type: "address",
                internalType: "Currency"
              },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              },
              { name: "hookData", type: "bytes", internalType: "bytes" }
            ]
          },
          { name: "exactAmount", type: "uint128", internalType: "uint128" }
        ]
      }
    ],
    outputs: [
      { name: "amountIn", type: "uint256", internalType: "uint256" },
      { name: "gasEstimate", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "quoteExactOutputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              { name: "currency0", type: "address", internalType: "Currency" },
              { name: "currency1", type: "address", internalType: "Currency" },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              }
            ]
          },
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "exactAmount", type: "uint128", internalType: "uint128" },
          { name: "hookData", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [
      { name: "amountIn", type: "uint256", internalType: "uint256" },
      { name: "gasEstimate", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unlockCallback",
    inputs: [{ name: "data", type: "bytes", internalType: "bytes" }],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "error",
    name: "NotEnoughLiquidity",
    inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }]
  },
  { type: "error", name: "NotPoolManager", inputs: [] },
  { type: "error", name: "NotSelf", inputs: [] },
  {
    type: "error",
    name: "QuoteSwap",
    inputs: [{ name: "amount", type: "uint256", internalType: "uint256" }]
  },
  { type: "error", name: "UnexpectedCallSuccess", inputs: [] },
  {
    type: "error",
    name: "UnexpectedRevertBytes",
    inputs: [{ name: "revertData", type: "bytes", internalType: "bytes" }]
  }
];
var derc20Abi = [
  {
    type: "constructor",
    inputs: [
      { name: "name_", type: "string", internalType: "string" },
      { name: "symbol_", type: "string", internalType: "string" },
      { name: "initialSupply", type: "uint256", internalType: "uint256" },
      { name: "recipient", type: "address", internalType: "address" },
      { name: "owner_", type: "address", internalType: "address" },
      { name: "yearlyMintRate_", type: "uint256", internalType: "uint256" },
      { name: "vestingDuration_", type: "uint256", internalType: "uint256" },
      { name: "recipients_", type: "address[]", internalType: "address[]" },
      { name: "amounts_", type: "uint256[]", internalType: "uint256[]" },
      { name: "tokenURI_", type: "string", internalType: "string" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "CLOCK_MODE",
    inputs: [],
    outputs: [{ name: "", type: "string", internalType: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "DOMAIN_SEPARATOR",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "allowance",
    inputs: [
      { name: "owner", type: "address", internalType: "address" },
      { name: "spender", type: "address", internalType: "address" }
    ],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "approve",
    inputs: [
      { name: "spender", type: "address", internalType: "address" },
      { name: "value", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "balanceOf",
    inputs: [{ name: "account", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "burn",
    inputs: [{ name: "amount", type: "uint256", internalType: "uint256" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "checkpoints",
    inputs: [
      { name: "account", type: "address", internalType: "address" },
      { name: "pos", type: "uint32", internalType: "uint32" }
    ],
    outputs: [
      {
        name: "",
        type: "tuple",
        internalType: "struct Checkpoints.Checkpoint208",
        components: [
          { name: "_key", type: "uint48", internalType: "uint48" },
          { name: "_value", type: "uint208", internalType: "uint208" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "clock",
    inputs: [],
    outputs: [{ name: "", type: "uint48", internalType: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "computeAvailableVestedAmount",
    inputs: [{ name: "account", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "currentYearStart",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "decimals",
    inputs: [],
    outputs: [{ name: "", type: "uint8", internalType: "uint8" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "delegate",
    inputs: [{ name: "delegatee", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "delegateBySig",
    inputs: [
      { name: "delegatee", type: "address", internalType: "address" },
      { name: "nonce", type: "uint256", internalType: "uint256" },
      { name: "expiry", type: "uint256", internalType: "uint256" },
      { name: "v", type: "uint8", internalType: "uint8" },
      { name: "r", type: "bytes32", internalType: "bytes32" },
      { name: "s", type: "bytes32", internalType: "bytes32" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "delegates",
    inputs: [{ name: "account", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "eip712Domain",
    inputs: [],
    outputs: [
      { name: "fields", type: "bytes1", internalType: "bytes1" },
      { name: "name", type: "string", internalType: "string" },
      { name: "version", type: "string", internalType: "string" },
      { name: "chainId", type: "uint256", internalType: "uint256" },
      { name: "verifyingContract", type: "address", internalType: "address" },
      { name: "salt", type: "bytes32", internalType: "bytes32" },
      { name: "extensions", type: "uint256[]", internalType: "uint256[]" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPastTotalSupply",
    inputs: [{ name: "timepoint", type: "uint256", internalType: "uint256" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getPastVotes",
    inputs: [
      { name: "account", type: "address", internalType: "address" },
      { name: "timepoint", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getVestingDataOf",
    inputs: [{ name: "account", type: "address", internalType: "address" }],
    outputs: [
      { name: "totalAmount", type: "uint256", internalType: "uint256" },
      { name: "releasedAmount", type: "uint256", internalType: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "getVotes",
    inputs: [{ name: "account", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "isPoolUnlocked",
    inputs: [],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "lastMintTimestamp",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "lockPool",
    inputs: [{ name: "pool_", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "mintInflation",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "name",
    inputs: [],
    outputs: [{ name: "", type: "string", internalType: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "nonces",
    inputs: [{ name: "owner_", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "numCheckpoints",
    inputs: [{ name: "account", type: "address", internalType: "address" }],
    outputs: [{ name: "", type: "uint32", internalType: "uint32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "owner",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "permit",
    inputs: [
      { name: "owner", type: "address", internalType: "address" },
      { name: "spender", type: "address", internalType: "address" },
      { name: "value", type: "uint256", internalType: "uint256" },
      { name: "deadline", type: "uint256", internalType: "uint256" },
      { name: "v", type: "uint8", internalType: "uint8" },
      { name: "r", type: "bytes32", internalType: "bytes32" },
      { name: "s", type: "bytes32", internalType: "bytes32" }
    ],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "pool",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "release",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "renounceOwnership",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "symbol",
    inputs: [],
    outputs: [{ name: "", type: "string", internalType: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "tokenURI",
    inputs: [],
    outputs: [{ name: "", type: "string", internalType: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "totalSupply",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "transfer",
    inputs: [
      { name: "to", type: "address", internalType: "address" },
      { name: "value", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferFrom",
    inputs: [
      { name: "from", type: "address", internalType: "address" },
      { name: "to", type: "address", internalType: "address" },
      { name: "value", type: "uint256", internalType: "uint256" }
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "transferOwnership",
    inputs: [{ name: "newOwner", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "unlockPool",
    inputs: [],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "updateMintRate",
    inputs: [{ name: "newMintRate", type: "uint256", internalType: "uint256" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "updateTokenURI",
    inputs: [{ name: "tokenURI_", type: "string", internalType: "string" }],
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "vestedTotalAmount",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "vestingDuration",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "vestingStart",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "yearlyMintRate",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        name: "owner",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "spender",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "DelegateChanged",
    inputs: [
      {
        name: "delegator",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "fromDelegate",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "toDelegate",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "DelegateVotesChanged",
    inputs: [
      {
        name: "delegate",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "previousVotes",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      },
      {
        name: "newVotes",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  { type: "event", name: "EIP712DomainChanged", inputs: [], anonymous: false },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      {
        name: "previousOwner",
        type: "address",
        indexed: true,
        internalType: "address"
      },
      {
        name: "newOwner",
        type: "address",
        indexed: true,
        internalType: "address"
      }
    ],
    anonymous: false
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      { name: "from", type: "address", indexed: true, internalType: "address" },
      { name: "to", type: "address", indexed: true, internalType: "address" },
      {
        name: "value",
        type: "uint256",
        indexed: false,
        internalType: "uint256"
      }
    ],
    anonymous: false
  },
  { type: "error", name: "ArrayLengthsMismatch", inputs: [] },
  { type: "error", name: "CheckpointUnorderedInsertion", inputs: [] },
  { type: "error", name: "ECDSAInvalidSignature", inputs: [] },
  {
    type: "error",
    name: "ECDSAInvalidSignatureLength",
    inputs: [{ name: "length", type: "uint256", internalType: "uint256" }]
  },
  {
    type: "error",
    name: "ECDSAInvalidSignatureS",
    inputs: [{ name: "s", type: "bytes32", internalType: "bytes32" }]
  },
  {
    type: "error",
    name: "ERC20ExceededSafeSupply",
    inputs: [
      { name: "increasedSupply", type: "uint256", internalType: "uint256" },
      { name: "cap", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "ERC20InsufficientAllowance",
    inputs: [
      { name: "spender", type: "address", internalType: "address" },
      { name: "allowance", type: "uint256", internalType: "uint256" },
      { name: "needed", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "ERC20InsufficientBalance",
    inputs: [
      { name: "sender", type: "address", internalType: "address" },
      { name: "balance", type: "uint256", internalType: "uint256" },
      { name: "needed", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "ERC20InvalidApprover",
    inputs: [{ name: "approver", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "ERC20InvalidReceiver",
    inputs: [{ name: "receiver", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "ERC20InvalidSender",
    inputs: [{ name: "sender", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "ERC20InvalidSpender",
    inputs: [{ name: "spender", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "ERC2612ExpiredSignature",
    inputs: [{ name: "deadline", type: "uint256", internalType: "uint256" }]
  },
  {
    type: "error",
    name: "ERC2612InvalidSigner",
    inputs: [
      { name: "signer", type: "address", internalType: "address" },
      { name: "owner", type: "address", internalType: "address" }
    ]
  },
  {
    type: "error",
    name: "ERC5805FutureLookup",
    inputs: [
      { name: "timepoint", type: "uint256", internalType: "uint256" },
      { name: "clock", type: "uint48", internalType: "uint48" }
    ]
  },
  { type: "error", name: "ERC6372InconsistentClock", inputs: [] },
  {
    type: "error",
    name: "InvalidAccountNonce",
    inputs: [
      { name: "account", type: "address", internalType: "address" },
      { name: "currentNonce", type: "uint256", internalType: "uint256" }
    ]
  },
  { type: "error", name: "InvalidShortString", inputs: [] },
  {
    type: "error",
    name: "MaxPreMintPerAddressExceeded",
    inputs: [
      { name: "amount", type: "uint256", internalType: "uint256" },
      { name: "limit", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "MaxTotalPreMintExceeded",
    inputs: [
      { name: "amount", type: "uint256", internalType: "uint256" },
      { name: "limit", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "MaxTotalVestedExceeded",
    inputs: [
      { name: "amount", type: "uint256", internalType: "uint256" },
      { name: "limit", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "MaxYearlyMintRateExceeded",
    inputs: [
      { name: "amount", type: "uint256", internalType: "uint256" },
      { name: "limit", type: "uint256", internalType: "uint256" }
    ]
  },
  { type: "error", name: "MintingNotStartedYet", inputs: [] },
  { type: "error", name: "NoMintableAmount", inputs: [] },
  {
    type: "error",
    name: "OwnableInvalidOwner",
    inputs: [{ name: "owner", type: "address", internalType: "address" }]
  },
  {
    type: "error",
    name: "OwnableUnauthorizedAccount",
    inputs: [{ name: "account", type: "address", internalType: "address" }]
  },
  { type: "error", name: "PoolLocked", inputs: [] },
  {
    type: "error",
    name: "SafeCastOverflowedUintDowncast",
    inputs: [
      { name: "bits", type: "uint8", internalType: "uint8" },
      { name: "value", type: "uint256", internalType: "uint256" }
    ]
  },
  {
    type: "error",
    name: "StringTooLong",
    inputs: [{ name: "str", type: "string", internalType: "string" }]
  },
  { type: "error", name: "VestingNotStartedYet", inputs: [] },
  {
    type: "error",
    name: "VotesExpiredSignature",
    inputs: [{ name: "expiry", type: "uint256", internalType: "uint256" }]
  }
];
var dopplerLensAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "poolManager_",
        type: "address",
        internalType: "contract IPoolManager"
      },
      {
        name: "stateView_",
        type: "address",
        internalType: "contract IStateView"
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "_quoteDopplerLensDataExactInputSingle",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              { name: "currency0", type: "address", internalType: "Currency" },
              { name: "currency1", type: "address", internalType: "Currency" },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              }
            ]
          },
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "exactAmount", type: "uint128", internalType: "uint128" },
          { name: "hookData", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IPoolManager" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "quoteDopplerLensData",
    inputs: [
      {
        name: "params",
        type: "tuple",
        internalType: "struct IV4Quoter.QuoteExactSingleParams",
        components: [
          {
            name: "poolKey",
            type: "tuple",
            internalType: "struct PoolKey",
            components: [
              { name: "currency0", type: "address", internalType: "Currency" },
              { name: "currency1", type: "address", internalType: "Currency" },
              { name: "fee", type: "uint24", internalType: "uint24" },
              { name: "tickSpacing", type: "int24", internalType: "int24" },
              {
                name: "hooks",
                type: "address",
                internalType: "contract IHooks"
              }
            ]
          },
          { name: "zeroForOne", type: "bool", internalType: "bool" },
          { name: "exactAmount", type: "uint128", internalType: "uint128" },
          { name: "hookData", type: "bytes", internalType: "bytes" }
        ]
      }
    ],
    outputs: [
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" },
      { name: "tick", type: "int24", internalType: "int24" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    name: "stateView",
    inputs: [],
    outputs: [
      { name: "", type: "address", internalType: "contract IStateView" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    name: "unlockCallback",
    inputs: [{ name: "data", type: "bytes", internalType: "bytes" }],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "error",
    name: "DopplerLensData",
    inputs: [
      { name: "sqrtPriceX96", type: "uint160", internalType: "uint160" }
    ]
  },
  {
    type: "error",
    name: "NotEnoughLiquidity",
    inputs: [{ name: "poolId", type: "bytes32", internalType: "PoolId" }]
  },
  { type: "error", name: "NotPoolManager", inputs: [] },
  { type: "error", name: "NotSelf", inputs: [] },
  { type: "error", name: "UnexpectedCallSuccess", inputs: [] },
  {
    type: "error",
    name: "UnexpectedRevertBytes",
    inputs: [{ name: "revertData", type: "bytes", internalType: "bytes" }]
  }
];

export { airlockAbi, derc20Abi, dopplerAbi, dopplerLensAbi, governanceFactoryAbi, poolManagerAbi, stateViewAbi, uniswapV4InitializerAbi, universalRouterAbi, v4QuoterAbi };
//# sourceMappingURL=chunk-OAUUC2IW.mjs.map
//# sourceMappingURL=chunk-OAUUC2IW.mjs.map